import { gql } from '@apollo/client';
import SeoFragment from '../Seo/Fragments/SeoFragment';

export const SINGLE_PROFILE = gql`
query PROFILE_QUERY($limit: Int, $authorSlug: String!, $paged: Int, $excludeUS: Boolean) {
	profile: authorBy(slug: $authorSlug) {
		id
		databaseId
		modified
		date
		title
		content
		details {
			authorType
			usersProfilePicture {
				altText
				imageCredit: caption
				srcSet
				sourceUrl
				title
			}
		}
		distributions {
			nodes {
				slug
			}
		}
		seo {
			...SeoFragment
		}
		authorRecipes(authorSlug: $authorSlug, limit: $limit, paged: $paged, excludeUS: $excludeUS) {
			limit
			paged
			found_posts
			max_num_pages
			associatedRecipes: posts {
				author
				featuredImage
				featuredImageAlt
				is_video
				permalink
				postId
				postType
				reciperating
				recipetime
				serving
				slug
				title
				authors {
					id
					permalink
					slug
					title
				}
				featuredTag {
					id
					name
					slug
					uri
				}
			}
		}
	}
}
${SeoFragment}
`;
